export default __webpack_public_path__ + "static/mobile-bg-catalog-69a49bf8468fb1e898eaee15911dfc43.png";